import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconSize } from '../../../enums/icon.enum';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-sidebar-toggle',
  imports: [CommonModule, IconComponent],
  templateUrl: './sidebar-toggle.component.html',
  styleUrl: './sidebar-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarToggleComponent {
  IconSize = IconSize;
  @Output() toggle = new EventEmitter<void>();
  @Input() isExpanded = false;
}
